export default "__VITE_ASSET__80a844a0__"